import { ICB_DealRoomStatus, ICB_DealRoom } from '@core/classes/CoBrowsingModels';
import request from '@core/services/request';
import { AxiosResponse } from 'axios';

export const azureMediaServicesAPI = {
	getDealVideos: (fimenuId: any) => request.getMs(`/MediaServices/GetDealVideos?fimenuId=${fimenuId}`),
	uploadVideoChunk: (chunk: any) => request.postMs(`/MediaServices/UploadVideoChunk`, chunk),
	videoStreamSAS: (videoId: any, fimenuId: any) => request.getMs(`/MediaServices/VideoStreamSAS?videoId=${videoId}&fimenuId=${fimenuId}`),
	// Co-Browsing Endpoints
	getActiveEditorLogin: (dealRoomId: string): Promise<AxiosResponse<ICB_DealRoomStatus>> =>
		request.getMs(`/MediaServices/DealRoomHub/GetActiveEditorLogin?dealRoomId=${dealRoomId}`),
	getCoBrowsingRoomDetails: (dealRoomId: string): Promise<AxiosResponse<ICB_DealRoom>> =>
		request.getMs(`/MediaServices/DealRoomHub/GetRoomDetails?dealRoomId=${dealRoomId}`),
	getCoBrowsingRoomIdsByViewer: (viewerLogin: string): Promise<AxiosResponse<string[]>> =>
		request.getMs(`/MediaServices/DealRoomHub/GetAllRoomIdsForViewer?viewerLogin=${viewerLogin}`),
};
